import { Button } from '@hivebrite/design-system/Button';

import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { PageImageItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/pageImageItemAttributess';

const ResetImage = ({
  item,
  onChange,
}: ComponentSettingsTab<PageImageItemAttributes>) => {
  const handleChange = () => {
    onChange({
      id: item.id,
      values: [
        { settingKey: 'attributes.horizontalAlign', value: 'center' },
        { settingKey: 'attributes.width', value: null },
        { settingKey: 'attributes.height', value: null },
        { settingKey: 'attributes.left', value: null },
        { settingKey: 'attributes.top', value: null },
        { settingKey: 'attributes.imageRadius', value: 0 },
      ],
    });
  };

  return (
    <Button
      fontFamily="Inter"
      mb={2}
      onClick={handleChange}
      variant="secondary"
      width="100%"
    >
      {s__('Builder|Reset image')}
    </Button>
  );
};

export default ResetImage;
